import { generateReference } from './formatters'

export const generateSeedData = () => {
  const now = new Date()

  const user = {
    id: 'usr_1',
    name: 'Tunde Adeleke',
    email: 'demo@billvast.com',
    phone: '+234 802 123 4567',
    walletBalance: 250000,
    avatar:
      'https://ui-avatars.com/api/?name=Tunde+Adeleke&background=73C883&color=fff',
    kyc: {
      tier: 1 as const,
      status: 'verified' as const,
      documents: [
        {
          type: 'bvn' as const,
          status: 'verified' as const,
          submittedAt: new Date(
            now.getTime() - 30 * 24 * 60 * 60 * 1000,
          ).toISOString(),
          verifiedAt: new Date(
            now.getTime() - 29 * 24 * 60 * 60 * 1000,
          ).toISOString(),
          value: '****5678',
        },
      ],
      dailyLimit: 50000,
      tier1CompletedAt: new Date(
        now.getTime() - 29 * 24 * 60 * 60 * 1000,
      ).toISOString(),
    },
  }

  const campaigns = [
    {
      id: 'camp_1',
      title: 'Emergency Heart Surgery for 5-year-old Amina',
      shortDescription:
        'Help cover the surgery costs for Amina, a bright 5-year-old diagnosed with a rare heart condition.',
      description:
        'Help cover the surgery costs for Amina, a bright 5-year-old diagnosed with a rare heart condition. Every contribution brings her closer to a healthy life.',
      story:
        '<p>Amina is a vibrant 5-year-old who loves painting and playing with her older brother. Two months ago, she was diagnosed with a congenital heart defect that requires immediate surgery.</p><p>The surgery will take place at the National Hospital in Abuja, but the cost is far beyond what our family can afford. We have exhausted our savings on her initial treatments and hospital stays.</p><p>We are reaching out to our community and kind-hearted individuals to help us raise the funds needed for her surgery and post-operative care. Every Naira counts and brings Amina closer to a healthy, normal life.</p>',
      targetAmount: 3500000,
      raisedAmount: 1240000,
      category: 'Medical Emergency',
      endDate: new Date(now.getTime() + 12 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'Active',
      imageUrl:
        'https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&q=80&w=400&h=250',
      createdAt: new Date(
        now.getTime() - 10 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      userId: 'usr_2',
      organizerName: 'Chioma Okafor',
      organizerAvatar:
        'https://ui-avatars.com/api/?name=Chioma+Okafor&background=4DA768&color=fff',
      donorCount: 89,
      isUrgent: true,
      location: { state: 'Abuja', city: 'FCT' },
      verificationStatus: 'verified' as const,
      useOfFunds: [
        { item: 'Surgery Cost', percentage: 70 },
        { item: 'Medication', percentage: 15 },
        { item: 'Post-op Care', percentage: 15 },
      ],
    },
    {
      id: 'camp_2',
      title: 'Build a Library for Ibadan Community School',
      shortDescription:
        'Providing a dedicated learning space and books for over 500 primary school students.',
      description:
        'Providing a dedicated learning space and books for over 500 primary school students in Ibadan.',
      story:
        '<p>Education is the key to a brighter future, but the students at our local community school in Ibadan currently lack access to a proper library and reading materials.</p><p>This campaign aims to transform an unused classroom into a vibrant library, complete with bookshelves, reading tables, and a diverse collection of books suitable for primary school children.</p><p>Your support will help foster a love for reading and provide these children with the resources they need to succeed academically.</p>',
      targetAmount: 5000000,
      raisedAmount: 2100000,
      category: 'Community Projects',
      endDate: new Date(now.getTime() + 45 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'Active',
      imageUrl:
        'https://images.unsplash.com/photo-1541976844346-f18aeac57b06?auto=format&fit=crop&q=80&w=400&h=250',
      createdAt: new Date(
        now.getTime() - 20 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      userId: 'usr_3',
      organizerName: 'Ibadan Youth Forum',
      organizerAvatar:
        'https://ui-avatars.com/api/?name=Ibadan+Youth&background=FFB347&color=fff',
      donorCount: 45,
      isUrgent: false,
      location: { state: 'Oyo', city: 'Ibadan' },
      verificationStatus: 'verified' as const,
    },
    {
      id: 'camp_3',
      title: 'Support 50 Girls Through University Education',
      shortDescription:
        'Covering tuition and accommodation for 50 brilliant young women from low-income families.',
      description:
        'Covering tuition and accommodation for 50 brilliant young women from low-income families across Nigeria.',
      story:
        '<p>We believe that empowering women through education is one of the most effective ways to uplift communities. This initiative seeks to provide full scholarships for 50 talented young women who have gained admission into federal universities but cannot afford the fees.</p><p>The funds raised will cover their tuition, accommodation, and a small stipend for books for their first academic year.</p>',
      targetAmount: 15000000,
      raisedAmount: 8900000,
      category: 'Education',
      endDate: new Date(
        now.getTime() + 120 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      status: 'Active',
      imageUrl:
        'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&q=80&w=400&h=250',
      createdAt: new Date(
        now.getTime() - 30 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      userId: 'usr_4',
      organizerName: 'Women in Leadership NGO',
      organizerAvatar:
        'https://ui-avatars.com/api/?name=Women+NGO&background=006633&color=fff',
      donorCount: 234,
      isUrgent: false,
      location: { state: 'Lagos', city: 'Yaba' },
      verificationStatus: 'verified' as const,
    },
    {
      id: 'camp_4',
      title: 'Tech Startup Seed Fund: AgriSmart',
      shortDescription:
        'Raising initial capital for a local agritech startup helping farmers optimize crop yields.',
      description:
        'Raising initial capital for a local agritech startup helping farmers optimize crop yields using affordable IoT sensors.',
      story:
        '<p>AgriSmart is developing low-cost soil moisture and nutrient sensors tailored for smallholder farmers in Nigeria. Our goal is to help them increase their yields by providing real-time data on their mobile phones.</p><p>We have successfully tested our prototype and are now raising funds to manufacture our first batch of 500 sensors to distribute to a pilot group of farmers.</p>',
      targetAmount: 5000000,
      raisedAmount: 5000000,
      category: 'Business Capital',
      endDate: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'Completed',
      imageUrl:
        'https://images.unsplash.com/photo-1556761175-5973dc0f32d7?auto=format&fit=crop&q=80&w=400&h=250',
      createdAt: new Date(
        now.getTime() - 60 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      userId: 'usr_5',
      organizerName: 'AgriTech Innovators',
      organizerAvatar:
        'https://ui-avatars.com/api/?name=AgriTech&background=73C883&color=fff',
      donorCount: 112,
      isUrgent: false,
      location: { state: 'Kaduna', city: 'Zaria' },
      verificationStatus: 'verified' as const,
    },
    {
      id: 'camp_5',
      title: 'My Tech Bootcamp Tuition',
      shortDescription:
        'Help me transition into tech! I need funds to pay for a 6-month intensive full-stack development bootcamp.',
      description:
        'Help me transition into tech! I need funds to pay for a 6-month intensive full-stack development bootcamp.',
      story:
        '<p>Hi, I am Tunde. I have been self-studying web development for the past year and I am ready to take the next step. I have been accepted into a rigorous 6-month full-stack software engineering bootcamp, but I need help covering the tuition.</p><p>This program will give me the mentorship and structured learning I need to land my first job in tech and support my family.</p>',
      targetAmount: 300000,
      raisedAmount: 50000,
      category: 'Education',
      endDate: new Date(now.getTime() + 45 * 24 * 60 * 60 * 1000).toISOString(),
      status: 'Active',
      imageUrl:
        'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?auto=format&fit=crop&q=80&w=400&h=250',
      createdAt: new Date(
        now.getTime() - 2 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      userId: 'usr_1',
      organizerName: 'Tunde Adeleke',
      organizerAvatar:
        'https://ui-avatars.com/api/?name=Tunde+Adeleke&background=73C883&color=fff',
      donorCount: 5,
      isUrgent: false,
      location: { state: 'Lagos', city: 'Ikeja' },
      verificationStatus: 'pending' as const,
    },
  ]

  const donations = [
    {
      id: 'don_1',
      campaignId: 'camp_1',
      donorId: 'usr_1',
      donorName: 'Tunde Adeleke',
      amount: 5000,
      tipAmount: 250,
      message: 'Praying for a successful surgery for little Amina.',
      isAnonymous: false,
      isRecurring: false,
      paymentMethod: 'wallet' as const,
      transactionReference: generateReference('DON'),
      status: 'completed' as const,
      createdAt: new Date(
        now.getTime() - 8 * 24 * 60 * 60 * 1000,
      ).toISOString(),
    },
    {
      id: 'don_2',
      campaignId: 'camp_1',
      donorId: 'anon_1',
      donorName: 'Anonymous',
      amount: 25000,
      tipAmount: 0,
      message: 'Get well soon!',
      isAnonymous: true,
      isRecurring: false,
      paymentMethod: 'card' as const,
      transactionReference: generateReference('DON'),
      status: 'completed' as const,
      createdAt: new Date(
        now.getTime() - 5 * 24 * 60 * 60 * 1000,
      ).toISOString(),
    },
    {
      id: 'don_3',
      campaignId: 'camp_2',
      donorId: 'usr_1',
      donorName: 'Tunde Adeleke',
      amount: 10000,
      tipAmount: 500,
      message: 'Great initiative for the community.',
      isAnonymous: false,
      isRecurring: false,
      paymentMethod: 'card' as const,
      transactionReference: generateReference('DON'),
      status: 'completed' as const,
      createdAt: new Date(
        now.getTime() - 15 * 24 * 60 * 60 * 1000,
      ).toISOString(),
    },
  ]

  const payouts = [
    {
      id: 'pay_1',
      campaignId: 'camp_4',
      campaignTitle: 'Tech Startup Seed Fund: AgriSmart',
      organizerId: 'usr_5',
      amount: 5000000,
      fee: 0, // Zero fees for standard payout
      netAmount: 5000000,
      bankName: 'GTBank',
      accountNumber: '0123456789',
      accountName: 'AgriTech Innovators Ltd',
      status: 'completed' as const,
      createdAt: new Date(
        now.getTime() - 1 * 24 * 60 * 60 * 1000,
      ).toISOString(),
      completedAt: new Date(now.getTime() - 12 * 60 * 60 * 1000).toISOString(),
    },
  ]

  const transactions = [
    {
      id: 'tx_1',
      type: 'Wallet',
      title: 'Wallet Funding',
      amount: 100000,
      status: 'Completed',
      date: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('FND'),
    },
    {
      id: 'tx_2',
      type: 'Bills',
      title: 'Ikeja Electric Prepaid',
      amount: -15000,
      status: 'Completed',
      date: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('BIL'),
    },
    {
      id: 'tx_3',
      type: 'Diaspora',
      title: 'Transfer to John Doe',
      amount: -77500, // $50 * 1550
      status: 'Completed',
      date: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('TRF'),
    },
    {
      id: 'tx_4',
      type: 'Crowdfunding',
      title: 'Donation to Medical Fund',
      amount: -5000,
      status: 'Completed',
      date: new Date(now.getTime() - 8 * 24 * 60 * 60 * 1000).toISOString(),
      reference: donations[0].transactionReference,
    },
    {
      id: 'tx_5',
      type: 'Facility',
      title: 'Rent Payment - Ikota Villa',
      amount: -350000,
      status: 'Completed',
      date: new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000).toISOString(),
      reference: generateReference('RNT'),
    },
    {
      id: 'tx_6',
      type: 'Crowdfunding',
      title: 'Donation to Community School',
      amount: -10000,
      status: 'Completed',
      date: new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000).toISOString(),
      reference: donations[2].transactionReference,
    },
  ]

  const transfers = [
    {
      id: 'trf_1',
      sourceCurrency: 'USD',
      sourceAmount: 50,
      ngnAmount: 77500,
      recipientName: 'John Doe',
      bankName: 'GTBank',
      accountNumber: '0123456789',
      fee: 775,
      exchangeRate: 1550,
      status: 'Completed',
      date: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
      reference: transactions[2].reference,
    },
  ]

  const properties = [
    {
      id: 'prop_1',
      address: 'Apt 4B, Ikota Villa Estate, Lekki',
      type: 'Apartment',
      monthlyRent: 350000,
      role: 'Tenant' as const,
      landlordName: 'Chief Ojo',
      nextDueDate: new Date(
        now.getTime() + 345 * 24 * 60 * 60 * 1000,
      ).toISOString(),
    },
  ]

  const maintenanceRequests = [
    {
      id: 'req_1',
      propertyId: 'prop_1',
      issueType: 'Plumbing',
      description:
        'Leaking pipe under the kitchen sink causing water damage to the cabinets.',
      urgency: 'High',
      status: 'In Progress',
      createdAt: new Date(
        now.getTime() - 2 * 24 * 60 * 60 * 1000,
      ).toISOString(),
    },
  ]

  return {
    user,
    campaigns,
    transactions,
    transfers,
    properties,
    maintenanceRequests,
    donations,
    payouts,
  }
}
